import { render, staticRenderFns } from "./IconBetaNewLead.vue?vue&type=template&id=423615ab&"
import script from "./IconBetaNewLead.vue?vue&type=script&lang=ts&"
export * from "./IconBetaNewLead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports